import {
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";


export default function SectionHeaderSearch({
  searchValue,
  onSearchChange,
  onFilterClick,
  onColumnClick
}) {
  
  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      <TextField
        size="small"
        placeholder="Search"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          width: 220,
          color: "black",
          "& .MuiOutlinedInput-root": {
            borderRadius: 20,
            fontSize: 13,
            
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />

      <Button
        variant="outlined"
        size="small"
        startIcon={<FilterAltOutlinedIcon />}
        sx={{ borderRadius: 20, textTransform: "none", fontSize: 13, color: "black", border:"1px solid lightgray", fontWeight: 600 }}
        onClick={onFilterClick}
      >
        Add Filter
      </Button>

      <IconButton
        size="small"
        sx={{ border: "1px solid #e5e7eb", borderRadius: "50%", fontWeight: 600, color: "black" }}
        onClick={onColumnClick}
      >
        <ViewListOutlinedIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
